import React, { useEffect, useState } from "react";


export const getCookie = (name) => {
        let cookieValue = document.cookie
          .split("; ")
          .find((row) => row.startsWith(`${name}=`))
          ?.split("=")[1];
        return cookieValue;
};

export const setCookie = (name, value, days=7) => {
  let expires = "";
  const sameSiteValue = window.location.hostname.startsWith("localhost") ? "None" : "Strict";
  const domainValue = window.location.hostname.startsWith("localhost") ? "localhost" : process.env.REACT_APP_HOST;
  if (days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
  }
  let cookieString = name + "=" + (value || "") + expires + "; path=/";
  if (sameSiteValue) {
      cookieString += "; SameSite=" + sameSiteValue;
  }
  if (domainValue) {
      cookieString += "; domain=" + domainValue;
  }
  // If SameSite=None, Secure must be set
  if (sameSiteValue === 'None') {
      cookieString += "; Secure";
  }
  document.cookie = cookieString;
};

